import {useEffect, useRef} from "react";
import {SquadflixTvHook} from "../../../../../hooks/useSquadflixTv";
import {SquadflixSocketEmitEvents} from "../../../../app/squadflix-tv-mode/socket-utils/socket-send-events";
import {SquadflixLogsApi} from "../../../../../apis/squadflix-logs/SquadflixLogsApi";

type Props = {
    props: {
        downloadInfo: any;
        imagePath: string;
        title: string;
        customRuntime: number;
        videoUrl: string;
        onClosePlayer: () => void;
        originalVideoUrl: string;
        subtitles: any[];
        audios: any[];
        streaming: boolean;
        item: any;
        onGoNextEpisode: () => void;
        squadFlixTvHook: SquadflixTvHook;
    }
}

const SquadflixTVSendContent = ({props}: Props) => {
    const {
        downloadInfo,
        imagePath,
        title,
        customRuntime,
        videoUrl,
        onClosePlayer,
        originalVideoUrl,
        subtitles,
        audios,
        streaming,
        item,
        onGoNextEpisode,
        squadFlixTvHook
    } = props;

    const lastSendVideoRef = useRef<any>();

    useEffect(() => {
        const tmdbId = item.serie?.id ?? item.id;
        // send single event to log viewing
        SquadflixLogsApi.logSquadflixView({
            tmdbId,
            season: item.season_number,
            episode: item.episode_number,
            duration: 0,
        }).catch(e => {
            console.error("Error logging viewing", e);
        })

        const aux = {
            streamingVideoUrl: videoUrl,
            videoUrl: originalVideoUrl,
            subtitles,
            audios,
            item,
            runtime: customRuntime,
            downloadInfo,
            title,
            streaming
        };

        if (aux.audios?.length === lastSendVideoRef.current?.audios?.length && aux.subtitles?.length === lastSendVideoRef.current?.subtitles?.length && aux.videoUrl === lastSendVideoRef.current?.videoUrl) {
            return;
        }

        lastSendVideoRef.current = aux;
        SquadflixSocketEmitEvents.sendPlayingVideo(squadFlixTvHook.connectedReceptor, aux);
    }, [originalVideoUrl, subtitles, audios, item, customRuntime, downloadInfo, title, squadFlixTvHook, videoUrl, streaming]);

    return <div>
        Playing {title} in {squadFlixTvHook.connectedReceptor.name}
    </div>
}

export default SquadflixTVSendContent;
